export default __webpack_public_path__ + "static/media/loader-opportunities.14a17cdf.svg";